export const DEFAULT_MAX_OPTIONS_COUNT = 52;
export const DEFAULT_ROW_LABEL = 'Option';
export const DEFAULT_COL_LABEL = 'Label';
